import React from 'react';
import styles from '../SideDrawer.module.scss';

interface SideDrawerMobileHeaderProps {
    title: string;
    status?: React.ReactNode;
    controls?: React.ReactNode;
}

function SideDrawerMobileHeader({ title, status, controls }: SideDrawerMobileHeaderProps) {
    return (
        <>
            <div className={styles.MobileHeader}>
                <span className={styles.MobileHeaderTitle}>{title}</span>
                {status}
            </div>
            {controls && <div className={styles.MobileControls}>{controls}</div>}
        </>
    );
}

export default SideDrawerMobileHeader;
